<template>
  <div class="addproductpage" style="position: relative">
    <GStockLoader :loading="loading" />
    <CommonHeader :page="'Liste des produits'" />

    <b-container fluid style="padding-top: 20px">
      <div class="card shadow">
        <form @submit.prevent class="align-items-center">
          <h6 class="heading-small text-muted mb-4">Ajouter Produit</h6>

          <div class="pl-lg-4">
            <div class="row">
              <div class="col-lg-6">
                <!-- <base-input
                  alternative
                  label="Nom du produit"
                  placeholder="Nom du produit"
                  input-classes="form-control-alternative"
                  v-model="product.name"
                /> -->
                <ProductSPInput
                  @newName="product.name = $event"
                  @form="setForm"
                  @attributes="attributes = $event"
                />
              </div>
              <div
                class="col-lg-6"
                v-for="(attr, index) in attributes"
                :key="index"
              >
                <b-form-group
                  :label="attr"
                  v-if="values[attr] && values[attr].length > 0"
                >
                  <b-form-radio-group
                    :id="'btn-radios-' + index"
                    v-model="form[attr]"
                    :options="values[attr]"
                    name="radios-btn-default"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>
                <base-input
                  v-else
                  alternative
                  :label="attr"
                  :placeholder="attr"
                  input-classes="form-control-alternative"
                  v-model="form[attr]"
                />
              </div>
              <div class="col-lg-6">
                <base-input
                  alternative
                  label="Prix"
                  placeholder="Prix"
                  input-classes="form-control-alternative"
                  v-model="price"
                />
              </div>
              <div class="col-lg-6">
                <base-input
                  alternative
                  label="Pourcentage en %"
                  placeholder="Pourcentage en %"
                  input-classes="form-control-alternative"
                  v-model="percentage"
                />
              </div>
              <div
                class="col-lg-6"
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                {{ "Prix en main : " + originalPrice + " DT" }}
              </div>
              <div class="col-lg-6" style="padding-left: 0px">
                <b-dropdown id="dropdown-1" :text="getText" class="m-md-2">
                  <b-dropdown-item @click="selectedValidity = 30"
                    >30 jours</b-dropdown-item
                  >
                  <b-dropdown-item @click="selectedValidity = 90"
                    >90 jours</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="col-12">
                <i
                  >* Par défaut la durée de validité d'un article est fixée à
                  {{ defaultValidity }} jours.</i
                >
              </div>
            </div>
          </div>

          <hr class="my-4" />
          <!-- Description -->
          <center>
            <b-btn
              type="submit"
              style="
                background-color: #000;
                width: 150px;
                height: 50px;
                color: #fff;
              "
              @click="postProduct($event)"
              >Ajouter</b-btn
            >
          </center>
        </form>
      </div>
    </b-container>
  </div>
</template>
<script>
import CommonHeader from "@/components/CommonHeader";
import GStockLoader from "@/components/Loader";
import ProductSPInput from "./ProductSPInput";
import { get, post, postFile } from "@/mixins/api";
import constants from "@/mixins/constants";
export default {
  name: "AddProduct",
  components: {
    CommonHeader,
    GStockLoader,
    ProductSPInput,
  },
  mixins: [constants],
  data() {
    return {
      values: {},
      attributes: [],
      form: {},
      search: "",
      imagesToUpload: [],
      images: [],
      name: "",

      model: {
        categorie: null,

        titre: "",
        description: "",
        prix: "",
      },
      clients: [],
      product: {
        name: "",
        price: 0.0,
        percentage: 0.2,
        owner: null,
      },
      price: 0.0,
      originalPrice: 0.0,
      percentage: 20,
      loading: false,
      selectedValidity: undefined,
    };
  },
  watch: {
    defaultPercentageMath: {
      handler: function (newVal) {
        this.product.percentage = this.defaultPercentageMath;
        this.percentage = this.defaultPercentageText;
      },
      immediate: true,
    },
    price: {
      handler: function (newVal) {
        this.calculatePrice();
      },
    },
    percentage: {
      handler: function (newVal) {
        this.calculatePrice();
      },
    },
  },
  computed: {
    getText() {
      return !this.selectedValidity
        ? "Validité du produit"
        : this.selectedStatus == 30
        ? "30 jours"
        : this.selectedStatus == 90
        ? "90 jours"
        : "30 jours";
    },
  },
  methods: {
    setForm(form, values) {
      this.form = form;
      this.values = values || {};
    },
    calculatePrice() {
      try {
        if (
          isNaN(this.price) ||
          isNaN(this.percentage) ||
          this.price == "" ||
          this.percentage == ""
        )
          throw "";
        const price = parseFloat(this.price);
        const val = this.percentage;
        const percentage = parseFloat(val);
        this.originalPrice = (price * (1 - percentage / 100)).toFixed(2);
      } catch (exception) {
        this.originalPrice = 0.0;
      }
    },
    handleSelects(e) {
      this.images = [];
      this.imagesToUpload = e.target.files;
      console.log(this.imagesToUpload);
      let fileList = Array.prototype.slice.call(e.target.files);
      fileList.forEach((f) => {
        if (!f.type.match("image.*")) {
          return;
        }

        let reader = new FileReader();
        let that = this;

        reader.onload = function (e) {
          that.images.push(e.target.result);
        };
        reader.readAsDataURL(f);
      });
    },
    getClients() {
      get("clients").then((response) => {
        this.clients = response.data.data.map((it) => {
          return { text: it.fullname, value: it.id };
        });
      });
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
    postProduct(e) {
      e.stopPropagation();
      try {
        const stop =
          isNaN(this.originalPrice) ||
          isNaN(this.percentage) ||
          this.originalPrice == "" ||
          this.percentage == "";
        const price = parseFloat(this.price);
        const val = this.percentage;
        const percentage = parseFloat(val) / 100;
        if (
          this.product.owner != null &&
          price != 0 &&
          percentage != 0 &&
          this.product.name != "" &&
          !stop
        ) {
          this.product.price = price;
          this.product.percentage = percentage;
          this.product.validity = this.selectedValidity
            ? this.selectedValidity
            : this.defaultValidity;
          this.loading = true;
          this.product.attributes = "";
          const attr = [];
          Object.keys(this.form).forEach((element) => {
            attr.push(`${element}(:)${this.form[element]}`);
          });
          if (attr.length != 0) {
            this.product.attributes = attr.join(";");
          }
          post("product", this.product)
            .then((res) => {
              this.makeToast("Votre produit est bien ajouté", "success");
              this.originalPrice = 0;
              this.price = 0;
              this.product = { name: "", price: 0, owner: this.product.owner };
            })
            .catch((err) => {
              this.makeToast("Une erreur est survenue merci de résseayez.");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          throw "Invalid product";
        }
      } catch (e) {
        this.makeToast("Vérifiez les données que vous avez saisit.");
      }
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.product.owner = parseInt(id);
  },
};
</script>
                        
  
<style lang="scss" scoped>
img {
  float: left;
  border-style: none;
  width: 100px;
  height: 80px;
}
</style>
<style>
.addproductpage .btn-group-toggle {
  display: inline !important;
}
.addproductpage .btn-group-toggle label {
  margin: 3px !important;
}
</style>